import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import ModalWrapper from 'components/Modals/ModalWrapper';

const InputId = {
  country: 'country',
  tin: 'tin',
  noTinReason: 'noTinReason',
  noTinExplanation: 'noTinExplanation'
};

const AddCustomerJotrModal = ({
  dispatch,
  isAddJotrModalShown,
  onCancel,
  prevAddresses,
  jurisdictions,
  isPrimary
}) => {
  const [jotrValues, setAddressValues] = useState({
    country: '',
    tin: '',
    noTinReason: '',
    noTinExplanation: ''
  });

  const dispatchAddress = () => {
    const addressProps = {
      id: 0,
      clientId: 0,
      customerId: 0,
      source: 1,
      isWithholdingResidence: false,
      effectiveFrom: new Date(),
      isPrimary,
      regime: 0,
      isDeleted: false,
      country: jotrValues.country,
      tin: jotrValues.tin,
      noTinReason: jotrValues.noTinReason,
      noTinExplanation: jotrValues.noTinExplanation
    };
    dispatch(change('customerEditForm', 'taxResidencies', [...(prevAddresses || []), addressProps]));
  };

  const onConfirm = (value) => {
    dispatchAddress(value);
    onCancel();
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setAddressValues({ ...jotrValues, [name]: value });
  };

  return (
    <ModalWrapper
      headerClose={ false }
      isOpen={ isAddJotrModalShown }
      btnConfirmTitle="Submit"
      btnCancelTitle="Cancel"
      title="Add Tax Residence"
      modalSize="add-customer-jotr-modal"
      onConfirm={ () => onConfirm(jotrValues) }
      onCancel={ onCancel }
    >
      <form className="form add-customer-jotr-modal" id="customer-jotr-modal">
        <div className="columns mt-2">
          <div className="col-6 form-group">
            <label id={ `${ InputId.country }-label` }>Country</label>
            <select
              id={ InputId.country }
              name={ InputId.country }
              className="form-select"
              value={ jotrValues.country }
              onChange={ onChangeHandler }
            >
              <option value="">Please select...</option>
              {jurisdictions && jurisdictions.map(x => (
                <option key={ x.name }>{x.name}</option>
              ))}
            </select>
          </div>
          <div className="col-6 form-group">
            <label id={ `${ InputId.tin }-label` }>TIN</label>
            <input
              id={ InputId.tin }
              name={ InputId.tin }
              className="form-input"
              value={ jotrValues.tin }
              onChange={ onChangeHandler }
            />
          </div>
          <div className="col-6 form-group mt-2">
            <label id={ `${ InputId.noTinReason }-label` }>No TIN Reason</label>
            <input
              id={ InputId.noTinReason }
              name={ InputId.noTinReason }
              className="form-input"
              value={ jotrValues.noTinReason }
              onChange={ onChangeHandler }
            />
          </div>
          <div className="col-6 form-group mt-2">
            <label id={ `${ InputId.noTinExplanation }-label` }>No TIN Explanation</label>
            <input
              id={ InputId.noTinExplanation }
              name={ InputId.noTinExplanation }
              className="form-input"
              value={ jotrValues.noTinExplanation }
              onChange={ onChangeHandler }
            />
          </div>
        </div>
      </form>
    </ModalWrapper>
  );
};

AddCustomerJotrModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAddJotrModalShown: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  prevAddresses: PropTypes.arrayOf(PropTypes.shape()),
  jurisdictions: PropTypes.arrayOf(PropTypes.shape()),
  isPrimary: PropTypes.bool
};

AddCustomerJotrModal.defaultProps = {
  isAddJotrModalShown: false,
  prevAddresses: null,
  jurisdictions: null,
  isPrimary: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(AddCustomerJotrModal);
